import { render, staticRenderFns } from "./GameView.vue?vue&type=template&id=66839a0d&scoped=true"
import script from "./GameView.vue?vue&type=script&lang=js"
export * from "./GameView.vue?vue&type=script&lang=js"
import style0 from "./GameView.vue?vue&type=style&index=0&id=66839a0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66839a0d",
  null
  
)

export default component.exports